import HomePageContent from './HomePageContent'

function HomePage() {
  return <HomePageContent />
}

export default HomePage
